import axios from "axios";
import { environment } from "../../environments/environment";
import { ListResponse } from "./utils";

export interface User {
    username: string,
    email: string,
    first_name: string
};

export interface Candidate {
    full_name: string,
    email: string,
    gender: string,
    date_of_birth: string,
    marital_status: string,
    education_level: string,
    disability: string,
    salary_expectation: number,
    cpf: string,
    rg: string,
    phone: string,
    mobile: string,
    status: string,
    address: string,
    city: string,
    cnh_category: string,
    usertype?: string,
    skills: number[]
};

export interface CreateCandidate {
    username: string,
    cpf: string,
    email: string,
    mobile: string,
    date_of_birth: string,
    password: string,
    gender: string,
    marital_status: string,
    salary_expectation: number,
    city_id: number,
    postcode?: string,
    address?: string,
    address_number?: string,
    address_district?: string,
    address_complement?: string,
    city_uf?: string,
    escola_do_mecanico_id?: number,
    skills: number[]
};

export const createCandidate = async (data: CreateCandidate): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/candidate/register/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const retrieveCandidate = async (candidate_id?: string) => {
    const response = await axios.get<Candidate>(environment.apiUrl+'/api/candidate/'+(candidate_id ? candidate_id : localStorage.getItem('candidate_id')), {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const listCandidates = async () => {
    const response = await axios.get<ListResponse<Candidate>>(environment.apiUrl+'/api/candidates/', {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const updateCandidate = async (id: string, data: CreateCandidate): Promise<any> => {
    const response = await axios.put<any>(environment.apiUrl+'/api/candidate/'+id, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};